import { QueryOptions, useQuery } from '@tanstack/react-query';
import { RQ_RULE_GROUPS } from 'Utils';
import { getAllRuleGroups } from 'Services';

function useGetRuleGroups({ queryOptions }: { queryOptions?: QueryOptions<RuleGroups> } = {}) {
    return useQuery([RQ_RULE_GROUPS], getAllRuleGroups, {
        select: (data) => {
            const groupNamePairs = data
                ?.map(({ id, name }) => ({
                    key: String(id),
                    displayValue: name
                }))
                .sort((a, b) => (a.displayValue > b.displayValue ? 1 : -1));
            return groupNamePairs;
        },
        ...queryOptions
    });
}

export default useGetRuleGroups;
